/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { removeLegacyTimestampNamespaceKeys } from '@jira/platform__browser-storage-providers/src/removeLegacyTimestampNamespaceKeys.tsx';
import { autoBeforeEachTest } from '@jira/platform__utils-auto-before-each-test/src/auto-before-each-test.tsx';
import { initializeControls } from '@atlassian/browser-storage-controls/controllers/cookie-controls/initialize-controls';
import type { BscInitializationResult } from '@atlassian/browser-storage-controls/types';
import { fg } from '@atlassian/jira-feature-gating';
// eslint-disable-next-line jira/restricted/fedramp-isolated-cloud
import { isFedRamp } from '@atlassian/atl-context';

import { shouldEnforceKeyForRollout } from '../rollout-enforcement/shouldEnforceKeyForRollout.tsx';

let initializeControlsPromise: Promise<BscInitializationResult | undefined> | null = null;

export function initControlsOnce({
	userId,
	cloudId,
}: {
	userId: string | undefined;
	cloudId: string | undefined;
}): Promise<BscInitializationResult | undefined> {
	if (!initializeControlsPromise) {
		if (fg('jfp-vulcan-browser-storage-disable-auto-cleanup')) {
			removeLegacyTimestampNamespaceKeys();
		}
		initializeControlsPromise = initializeControls({
			product: 'Jira',
			webStorageEnabled:
				fg('jfp-vulcan-browser-storage-analytics-enabled') ||
				fg('jfp-vulcan-browser-storage-enabled'),
			disableWebStorageConsentChecks:
				fg('jfp-vulcan-browser-storage-analytics-enabled') &&
				!fg('jfp-vulcan-browser-storage-enabled'),
			indexedDbEnabled:
				fg('jfp-vulcan-indexeddb-analytics-enabled') || fg('jfp-vulcan-indexeddb-enabled'),
			disableIndexedDbConsentChecks:
				fg('jfp-vulcan-indexeddb-analytics-enabled') && !fg('jfp-vulcan-indexeddb-enabled'),
			perimeter: isFedRamp() ? 'fedramp-moderate' : 'commercial',
			userId,
			cloudId,
			allowUncategorizedItemsInWebStorageOverrides: !fg(
				'jfp-vulcan-browser-storage-block-uncategorized',
			),
			__UNSAFE_shouldEnforceKeyForRollout: shouldEnforceKeyForRollout,
		});
	}
	return initializeControlsPromise;
}

autoBeforeEachTest(() => {
	initializeControlsPromise = null;
});
